import type { ExercisesList, LearningActivity, Teacher, Tool } from "types";

export const handleTeachersAndTutors = (
  teachers: Teacher[],
  tutors: Teacher[],
  t: (key: string, fallback: string) => string
): Array<Teacher & { role: string }> => {
  return [
    ...teachers.map((teacher: Teacher) => ({
      ...teacher,
      role: t("teacher", "Docente")
    })),
    ...tutors.map((tutor: Teacher) => ({
      ...tutor,
      role: t("tutor", "Tutor")
    }))
  ];
};
export const handleFirstTab = (learningObject: LearningActivity, tools: Tool[], exercises: ExercisesList) => {
  if (learningObject?.learningObjectTypology === "DA_PHYSICAL_CLASS" || learningObject?.learningObjectTypology === "DA_VIRTUAL_CLASS") {
    return "editions";
  }
  if (learningObject?.useful_links?.length > 0 || (tools && tools.length > 0)) {
    return "resources";
  }
  if (learningObject?.teachers?.length > 0) {
    return "teachers";
  }
  if (exercises && exercises.length > 0) {
    return "exercises";
  }
  return "editions";
};

export const ctaDisabled = (activity: LearningActivity) => !activity.canAccessNow 
  || activity.isTest && activity.status === "C"
  || (activity.enrollmentStatus === "W" || activity.status === "W") 
  || activity.isEnable === false 
  || (Boolean(activity.ecm_specialization && !activity.ecmRegistration));
